import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Fund from './pages/Fund';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"           element={<Home />} />
        <Route path="/fund/:code" element={<Fund />} />
      </Routes>
    </BrowserRouter>
  );
}
